import { Controller } from '@hotwired/stimulus';
export default class extends Controller {
    static targets = ['btn'];
    static classes = ['active'];

    switch(event) {
        const button = event.currentTarget;
        const tabId = button.dataset.tabId;

        this.btnTargets.forEach((b) => {
            b.classList.toggle(this.activeClass, b === button);
        });

        const scope = this.element.closest('[data-tabs-scope]') || document;
        scope.querySelectorAll('[data-tab-panel]').forEach((panel) => {
            panel.classList.toggle('tab-panel--active', panel.dataset.tabPanel === tabId);
        });
    }
}
